export class AccountRating {
  id: number = -1;
  name: string = '';
  createdAt: string = '';
  updatedAt: string = '';
}
